import { useState } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import RelatedPages from '@/components/base/RelatedPages';

const categories = [
  {
    id: 'brand',
    icon: 'ri-store-line',
    label: '品牌與市場行銷',
    faqs: [
      {
        q: '我完全沒有做過保健食品，也適合找你們 ODM 嗎？',
        a: '非常適合。養健康專為新創品牌、電商品牌、網紅與團購通路設計「低門檻 ODM 流程」，從市場定位、功效方向、配方設計、法規檢視到量產上市，全程由專業團隊陪跑。',
      },
      {
        q: '我有粉絲或團購通路，但不確定做什麼產品比較好？',
        a: '我們會依您的客群屬性（年齡、性別、生活型態、銷售情境）協助您選擇適合的功效方向與劑型，避免做出賣不動或法規風險高的產品。',
      },
      {
        q: 'ODM 產品會不會跟市場上的產品太像？',
        a: '不會。我們提供客製化配方調整與原料組合建議，避免單純套用公版配方，讓產品具備市場差異性與銷售品牌故事。',
      },
      {
        q: '對於產品配方還沒有具體的想法，我還是可以找康永嗎？',
        a: '當然可以，我們會依據您的銷售通路與目標客群，提供市場分析與配方建議，針對不同階段的品牌需求，我們也提供兩大核心方案：\n\n專屬獨家開發配方：根據您的需求，從零開始研發具備市場差異化與獨特競爭力的配方\n\n成熟配方的應用：我們提供多款經市場驗證、安定性高且受消費者喜愛的熱銷配方及成熟半成品，能協助您快速且無痛的進入市場',
      },
    ],
  },
  {
    id: 'risk',
    icon: 'ri-shield-check-line',
    label: '少量起步與風險控管',
    faqs: [
      {
        q: '我預算有限，可以少量製作嗎？',
        a: '可以。我們支援少量試單與低庫存起步方案，適合新創品牌、直播主與團購主測試市場反應。相關劑型製作最低量(MOQ)資訊請點選「代工劑型」頁面。',
      },
      {
        q: '如果產品賣不好怎麼辦？',
        a: '我們會在前期協助您避開高風險功效與原料，並建議市場接受度高的產品方向，降低滯銷風險。',
      },
      {
        q: '是否能先打樣確認口感與效果？',
        a: '可以。ODM 專案皆可安排樣品試樣與配方微調，讓您實際確認口感與方向，確保產品符合您的銷售需求再進行量產。各項產品效果會依照產品性質及個人體質有所異同，部分產品效果可在打樣時做同步確認，相關打樣費用資訊請點選「代工劑型」頁面。',
      },
    ],
  },
  {
    id: 'regulation',
    icon: 'ri-file-text-line',
    label: '法規與合法行銷',
    faqs: [
      {
        q: '食品不能宣稱療效，那行銷文案怎麼寫？',
        a: '我們熟悉台灣食品相關法規與合法用詞，可協助調整產品名稱、包裝文案與銷售說明，避免違規風險。',
      },
      {
        q: '是否協助食品標示與營養標示計算？',
        a: '是的，我們可協助依照食品法規完整食品標示、營養標示計算與文案檢視。',
      },
      {
        q: '網紅直播或團購話術會不會違法？',
        a: '我們可提供合法用語方向與建議，協助您在直播或團購平台安全銷售。',
      },
    ],
  },
  {
    id: 'channel',
    icon: 'ri-shopping-bag-line',
    label: '通路與銷售支援',
    faqs: [
      {
        q: '適合哪些通路銷售ODM的產品？',
        a: '電商平台、直播銷售、社群團購、直銷體系、寵物通路與醫療保健等相關單位都非常適合喔。',
      },
      {
        q: '是否提供產品教育或銷售素材？',
        a: '我們可提供產品特色說明、成分重點整理與內部教育訓練素材。',
      },
      {
        q: '可以做寵物保健食品嗎？',
        a: '可以。我們擁有寵物保健食品製作的經驗，提供犬貓和兔子的配方設計，並依相關規範協助製作。',
      },
    ],
  },
  {
    id: 'production',
    icon: 'ri-settings-3-line',
    label: '製程、交期與品質',
    faqs: [
      {
        q: '產品製作需要多久？',
        a: '一般產品製程約 30–60 個工作天，初次合作需要確認事項較多時間會稍長一些，實際時程依產品複雜度調整。',
      },
      {
        q: '工廠是否有國際認證？',
        a: '我們工廠具備國際 ISO22000 與 HACCP 認證，且可提供產品生產證明之證書，確保產品生產品質。',
      },
      {
        q: '是否能做外銷或跨境？',
        a: '可協助您進行相關評估，但仍需依目標市場法規進一步確認。',
      },
      {
        q: '是否提供第三方檢驗認證？',
        a: '是的。我們可依照客戶需求，協助安排第三方檢驗（如 SGS 等）。',
      },
      {
        q: '包裝與設計是否一定要自己準備？',
        a: '不需要。我們提供完整包材設計與印刷整合服務，從彩盒、鋁包、瓶器到 PTP 包裝皆可客製，並協助確認相關法規標示。相關包材資訊請點選「包材設計」頁面。',
      },
    ],
  },
  {
    id: 'trust',
    icon: 'ri-shake-hands-line',
    label: '合作與信任',
    faqs: [
      {
        q: '是否可簽署保密協議（NDA）？',
        a: '可以。我們重視客戶配方與商業資訊安全，可依客戶需求簽署保密協議。',
      },
      {
        q: '哪些業者最適合找康永合作？',
        a: '新創品牌、電商經營者、網紅直播主、團購主、直銷通路、寵物品牌與醫療保健相關單位，都歡迎您與我們諮詢合作。',
      },
    ],
  },
  {
    id: 'export',
    icon: 'ri-global-line',
    label: '海外銷售與跨境市場',
    faqs: [
      {
        q: '海外銷售是否需要重新調整配方或標示？',
        a: '視銷售國家而定。不同國家對食品原料、添加量、標示語言與格式皆有差異，我們可於前期協助評估，避免成品完成後無法出口。',
      },
      {
        q: '是否能協助規劃多國版本產品？',
        a: '可以。我們可依不同市場需求，協助設計同一產品的多版本配方或標示版本，讓品牌能彈性拓展不同國家通路。',
      },
    ],
  },
];

export default function FaqContent() {
  const [activeCategory, setActiveCategory] = useState('brand');
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const currentCat = categories.find((c) => c.id === activeCategory)!;

  const handleCatChange = (id: string) => {
    setActiveCategory(id);
    setOpenIdx(null);
  };

  return (
    <>
      {/* Hero Banner */}
      <section className="relative pt-20 min-h-[320px] md:min-h-[380px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=person%20reading%20FAQ%20document%20health%20supplement%20product%20brochure%20on%20clean%20white%20desk%20with%20green%20plant%2C%20professional%20customer%20support%20service%20concept%2C%20bright%20natural%20lighting%20minimal&width=1920&height=380&seq=faq-hero-bg-01&orientation=landscape"
            alt="常見問題背景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#1a3a1a]/90 via-[#1a3a1a]/65 to-[#1a3a1a]/20" />
        </div>
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-14 pt-24">
          <div className="max-w-2xl">
            <Breadcrumb
              items={[
                { label: '首頁', href: '/' },
                { label: '合作相關', href: '/cooperation' },
                { label: '常見問題' },
              ]}
              className="mb-4 text-gray-300"
            />
            <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5">
              合作相關
            </span>
            <h1 className="text-white font-bold text-[2.25rem] md:text-[2.875rem] leading-tight mb-4">
              常見問題
            </h1>
            <p className="text-gray-200 text-[1.0625rem] leading-[1.75] max-w-xl">
              整理了品牌客戶最常詢問的問題，依主題分類方便快速查找。
            </p>
          </div>
        </div>
      </section>

      {/* FAQ layout */}
      <section className="py-16 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="flex flex-col lg:flex-row gap-8">

            {/* Left: categories */}
            <div className="w-full lg:w-[260px] flex-shrink-0">
              <h2 className="text-[#1a2e1a] font-bold text-[1rem] mb-4 px-1">問題分類</h2>
              <div className="flex flex-row lg:flex-col flex-wrap gap-2">
                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    onClick={() => handleCatChange(cat.id)}
                    className={`flex items-center gap-2.5 px-4 py-3 rounded-xl text-left transition-all duration-200 cursor-pointer whitespace-nowrap ${
                      activeCategory === cat.id
                        ? 'bg-[#4CAF50] text-white'
                        : 'bg-white text-gray-600 border border-gray-100 hover:border-green-200 hover:text-[#4CAF50]'
                    }`}
                  >
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                      <i className={`${cat.icon} text-sm`} />
                    </div>
                    <span className="text-[0.875rem] font-medium">{cat.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Right: FAQs */}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-9 h-9 flex items-center justify-center bg-[#4CAF50] rounded-xl">
                  <i className={`${currentCat.icon} text-white text-base`} />
                </div>
                <h2 className="text-[#1a2e1a] font-bold text-[1.25rem]">{currentCat.label}</h2>
                <span className="text-gray-400 text-[0.8125rem]">{currentCat.faqs.length} 個問題</span>
              </div>

              <div className="space-y-3">
                {currentCat.faqs.map((faq, idx) => (
                  <div
                    key={idx}
                    className={`bg-white rounded-xl border overflow-hidden transition-all duration-200 ${
                      openIdx === idx ? 'border-[#4CAF50]/40' : 'border-gray-100 hover:border-green-200'
                    }`}
                  >
                    <button
                      className="w-full flex items-start justify-between px-6 py-5 text-left cursor-pointer"
                      onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                    >
                      <span className={`text-[1rem] font-semibold leading-snug pr-4 ${openIdx === idx ? 'text-[#4CAF50]' : 'text-[#1a2e1a]'}`}>
                        {faq.q}
                      </span>
                      <div className={`w-7 h-7 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5 transition-all duration-200 ${openIdx === idx ? 'bg-[#4CAF50] text-white' : 'bg-green-50 text-[#4CAF50]'}`}>
                        <i className={`text-sm ${openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'}`} />
                      </div>
                    </button>
                    {openIdx === idx && (
                      <div className="px-6 pb-5 border-t border-gray-50">
                        <p className="text-gray-600 text-[0.9375rem] leading-[1.8] pt-4 whitespace-pre-line">{faq.a}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Still have questions */}
      <section className="py-16 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="bg-[#f0faf0] border border-green-100 rounded-3xl px-8 lg:px-14 py-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1">
              <h2 className="text-[#1a2e1a] font-bold text-[1.625rem] leading-tight mb-3">
                沒找到您的問題？
              </h2>
              <p className="text-gray-500 text-[1.0625rem] leading-[1.75]">
                歡迎直接聯絡康永生技業務團隊，我們會盡快 回覆您的所有疑問。
              </p>
            </div>
            <div className="flex flex-wrap gap-4 flex-shrink-0">
              <Link
                to="/contact/form"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer"
              >
                直接諮詢我們
                <i className="ri-arrow-right-line" />
              </Link>
              <a
                href="https://lin.ee/X7Hcpf4"
                rel="nofollow"
                className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer"
              >
                <i className="ri-line-fill" />
                LINE 快速詢問
              </a>
            </div>
          </div>
        </div>
      </section>
      <RelatedPages items={[
        { title: '合作流程', desc: '從需求對焦到完成交貨，清楚掌握合作的每個步驟。', href: '/cooperation/process' },
        { title: '立即洽詢', desc: '填寫諮詢表單，康永專人會盡快與您聯繫。', href: '/cooperation/inquiry' },
        { title: '聯絡表單', desc: '填寫請問表單，從請問進入周密合作。', href: '/contact/form' },
      ]} />
    </>
  );
}
